import { Autocomplete, TextField } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { gstCategoryOptions } from '../../utils/customerData';

const SearchAutoComplete = ({ state, name, value, onChange, placeholder }) => {
    console.log(state, value, "123")
    return (
        <>
            <Autocomplete
                id={""}
                disableClearable
                options={gstCategoryOptions}
                getOptionLabel={(option) => option.text}
                isOptionEqualToValue={(option, value) => {
                    console.log({ value, option })
                    return option.id == value
                }
                }
                value={gstCategoryOptions.find(opt => opt.id === value) || null}
                clearIcon={
                    state?.[name] !== "" ? (
                        <ClearIcon style={{ fontSize: "20px" }} />
                    ) : null
                }
                onChange={(e, value) => {
                    console.log(value)
                    onChange(e, name, value?.id)
                }
                }
                size="small"
                fullWidth
                sx={{ height: "32px" }}
                renderOption={(props, option) => (
                    <>
                        <li {...props}>
                            {option.text}
                        </li>
                        {/* <MenuItem
                            {...props}
                            key={option.id}
                            value={option.id}
                        >
                            <ListItemText primary={option.label} />
                        </MenuItem> */}
                    </>
                )}
                renderInput={(params) => (
                    <TextField
                        value={value}
                        sx={{
                            minWidth: "100px",
                            border: "none", // Ensure border is removed
                            "& .MuiInput-underline:before": {
                                borderBottom: "none", // Remove underline in standard variant
                            },
                            "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                            {
                                borderBottom: "none", // Remove hover effect
                            },
                            "& .MuiInput-underline:after": {
                                borderBottom: "none", // Remove underline for focused state
                            },
                            "& fieldset": { border: "none" },
                        }}
                        placeholder={placeholder}
                        variant="standard"
                        InputLabelProps={{
                            style: { color: "black" },
                        }}
                        // onFocus={(e) => {
                        //     // When the input is focused, change the label to empty
                        //     e.target.placeholder = ""; // Remove placeholder text on focus if needed
                        // }}
                        // onBlur={(e) => {
                        //     // When the input loses focus, revert changes if necessary
                        //     e.target.placeholder = state?.[name]
                        //         ? ""
                        //         : "Search"; // Revert placeholder text on blur if needed
                        // }}
                        {...params}
                    />
                )}
            />
        </>
    )
}

export default SearchAutoComplete